import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login/Index.vue";
import Emails from "@/views/Emails/Index.vue";
import InfoEmail from "@/views/InfoEmail/Index.vue";
import UsersManagement from "@/views/UsersManagement/Index.vue";
import NonQuote from "@/views/NonQuote/Index.vue";
import NotFound from "@/views/NotFound/Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/usersManagement",
    name: "UsersManagement",
    props: true,
    component: UsersManagement
  },
  {
    path: "/:pathName",
    name: "Emails",
    props: true,
    component: Emails
  },
  {
    path: "/:pathName/:id",
    name: "InfoEmail",
    props: true,
    component: InfoEmail
  },
  {
    path: "/nonQuote/:pathName/:id",
    name: "NonQuote",
    props: true,
    component: NonQuote
  },
  {
    path: "/404",
    name: "NotFound",
    component: NotFound
  },
  {
    path: "*" /** El * Siempre al final o regex*/,
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
